import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { wsGenerarPDFService } from "src/app/services/wsGenerarPDF.service";
import { saveAs } from "file-saver";
import { GLOBAL } from "src/app/services/global";
declare var $: any;
@Component({
  selector: "app-formulario152",
  templateUrl: "./formulario152.component.html",
  styleUrls: ["./formulario152.component.css"],
  providers: [wsGenerarPDFService],
})
export class Formulario152Component implements OnInit {
  @ViewChild("dataHtml") dataHtml: ElementRef;
  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public color = "#C7C7EA";
  public data = "variable data del ts";
  pages = [1, 2, 3, 4, 5];

  public antecedentesPrevios;
  public propiedad;
  public propietarios;
  public representantePropietario;
  public personeria;
  public empresas;
  public arquitectos;
  public constructora;
  public constructoraProfesional;
  public inspectorObra;
  public inspectorProfesional;
  public cuentaRevisor;
  public revisor;
  public declaracion;
  public tipo_Proyecto;
  public Listado_Planos;
  public caract_anteproyecto_obranueva;
  public permisos_recep;
  public antecedentes;
  public constructores;
  public independiente;
  public proyecto;
  public Permisos;
  public caracteristica_proyecto;
  public ampliacion;
  public antecedentes_edif;
  public superficie;
  public unidades;

  constructor(
    private spinner: NgxSpinnerService,
    private _wsGenerarPDFService: wsGenerarPDFService
  ) {}

  ngOnInit() {}

  ngAfterContentChecked() {
    this.ngAfterContentInit();
  }

  ngAfterContentInit() {
    //ANTECEDENTES PREVIOS 🧾 ✅
    if (JSON.parse(localStorage.getItem("antecedentesPrevios"))) {
      if (JSON.parse(localStorage.getItem("antecedentesPrevios")).length > 0) {
        this.antecedentesPrevios = JSON.parse(
          localStorage.getItem("antecedentesPrevios")
        );
        if (
          this.antecedentesPrevios[0].datosExtrasAntecedentes ==
          "Recepción definitiva parcial"
        ) {
          $("#RECEPCIONDEFINITIVAPARCIAL").attr("checked", "checked");
        }
        if (
          this.antecedentesPrevios[0].datosExtrasAntecedentes ==
          "Recepción definitiva total"
        ) {
          $("#RECEPCIONDEFINITIVATOTAL").attr("checked", "checked");
        }
      } else {
        localStorage.setItem("antecedentesPrevios", JSON.stringify([]));
        this.antecedentesPrevios = [
          {
            datosExtrasAntecedentes: "",
            fechaProyecto: "",
            nombreProyecto: "",
            numeroProyecto: "",

            cipPermisoFechaProyecto: "",
            cipPermisoNumeroProyecto: "",

            permisoFechaProyecto: "",
            permisoNumeroProyecto: "",
            superficieModificacion: "",
            superficieModificada: "",
          },
        ];
      }
    } else {
      localStorage.setItem("antecedentesPrevios", JSON.stringify([]));
      this.antecedentesPrevios = [
        {
          datosExtrasAntecedentes: "",
          fechaProyecto: "",
          nombreProyecto: "",
          numeroProyecto: "",

          cipPermisoFechaProyecto: "",
          cipPermisoNumeroProyecto: "",

          permisoFechaProyecto: "",
          permisoNumeroProyecto: "",
          superficieModificacion: "",
          superficieModificada: "",
        },
      ];
    }

    //Datos de la propiedad 🏠✅
    if (JSON.parse(localStorage.getItem("informacionPropiedad"))) {
      if (JSON.parse(localStorage.getItem("informacionPropiedad")).length > 0) {
        this.propiedad = JSON.parse(
          localStorage.getItem("informacionPropiedad")
        );
      } else {
        localStorage.setItem("informacionPropiedad", JSON.stringify([]));
        this.propiedad = [
          {
            rol: "",
            id_direcc: "",
            folio: "",
            calle: "",
            calle_num: 0,
            direccion_completa: "",
            direc_complemento: "",
            direc_compl_num: "",
            loteo: "",
            manzana: "",
            plano: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("informacionPropiedad", JSON.stringify([]));
      this.propiedad = [
        {
          rol: "",
          id_direcc: "",
          folio: "",
          calle: "",
          calle_num: 0,
          direccion_completa: "",
          direc_complemento: "",
          direc_compl_num: "",
          loteo: "",
          manzana: "",
          plano: "",
          recordId: "",
        },
      ];
    }

    //PROPIETARIOS 🧔✅
    if (JSON.parse(localStorage.getItem("propietarios"))) {
      if (JSON.parse(localStorage.getItem("propietarios")).length > 0) {
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
      } else {
        localStorage.setItem("propietarios", JSON.stringify([]));
        this.propietarios = [
          {
            rut: "",
            nombre: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_num: "",
            direccion_complemento: "",
            direccion_completa: "",
            comuna: "",
            fono: "",
            fax: "",
            mail: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("propietarios", JSON.stringify([]));
      this.propietarios = [
        {
          rut: "",
          nombre: "",
          apellido_mat: "",
          apellido_pat: "",
          direccion: "",
          direccion_num: "",
          direccion_complemento: "",
          direccion_completa: "",
          comuna: "",
          fono: "",
          fax: "",
          mail: "",
          recordId: "",
        },
      ];
    }

    //REPRESENTANTE PROPIETARIO 🧔🏠✅
    if (JSON.parse(localStorage.getItem("propietarioRepresentante"))) {
      if (
        JSON.parse(localStorage.getItem("propietarioRepresentante")).length > 0
      ) {
        this.representantePropietario = JSON.parse(
          localStorage.getItem("propietarioRepresentante")
        ); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
      } else {
        localStorage.setItem("propietarioRepresentante", JSON.stringify([]));
        this.representantePropietario = [
          {
            rut: "",
            nombre: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_num: "",
            direccion_complemento: "",
            direccion_completa: "",
            comuna: "",
            fono: "",
            fax: "",
            mail: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("propietarioRepresentante", JSON.stringify([]));
      this.representantePropietario = [
        {
          rut: "",
          nombre: "",
          apellido_mat: "",
          apellido_pat: "",
          direccion: "",
          direccion_num: "",
          direccion_complemento: "",
          direccion_completa: "",
          comuna: "",
          fono: "",
          fax: "",
          mail: "",
          recordId: "",
        },
      ];
    }

    //PERSONERIA 👪🏠✅
    if (JSON.parse(localStorage.getItem("personeria"))) {
      if (JSON.parse(localStorage.getItem("personeria")).length > 0) {
        this.personeria = JSON.parse(localStorage.getItem("personeria"));
      } else {
        localStorage.setItem("personeria", JSON.stringify([]));
        this.personeria = [
          {
            aMediante: "",
            aFecha: "",
            escrituraFecha: "",
            notario: "",
            medInstrumento: "",
            oMediante: "",
            oFecha: "",
          },
        ];
      }
    } else {
      localStorage.setItem("personeria", JSON.stringify([]));
      this.personeria = [
        {
          aMediante: "",
          aFecha: "",
          escrituraFecha: "",
          notario: "",
          medInstrumento: "",
          oMediante: "",
          oFecha: "",
        },
      ];
    }

    //EMPRESAS 🏢👪✅
    if (JSON.parse(localStorage.getItem("empresas"))) {
      if (JSON.parse(localStorage.getItem("empresas")).length > 0) {
        this.empresas = JSON.parse(localStorage.getItem("empresas"));

        if (this.empresas[0].adjuntaComunicacion) {
          $("#adjuntaComunicacion").attr(
            "checked",
            this.empresas[0].adjuntaComunicacion
          );
        }
        if (this.empresas[0].mantieneProfesionales) {
          $("#mantieneProfesionales").attr(
            "checked",
            this.empresas[0].mantieneProfesionales
          );
        }
      } else {
        localStorage.setItem("empresas", JSON.stringify([]));
        this.empresas = [
          {
            rut: "",
            nombre: "",
            direccion: "",
            direccion_num: "",
            direccion_complemento: "",
            direccion_completa: "",
            comuna: "",
            fono: "",
            fax: "",
            mail: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("empresas", JSON.stringify([]));
      this.empresas = [
        {
          rut: "",
          nombre: "",
          direccion: "",
          direccion_num: "",
          direccion_complemento: "",
          direccion_completa: "",
          comuna: "",
          fono: "",
          fax: "",
          mail: "",
          recordId: "",
        },
      ];
    }

    //ARQUITECTOS 🏢👷✅
    if (JSON.parse(localStorage.getItem("arquitectos"))) {
      if (JSON.parse(localStorage.getItem("arquitectos")).length > 0) {
        this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"));
      } else {
        localStorage.setItem("arquitectos", JSON.stringify([]));
        this.arquitectos = [
          {
            rut: "",
            nombre: "",
            mail: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_complemento: "",
            direccion_num: "",
            comuna: "",
            fono: "",
            fax: "",
            patente: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("arquitectos", JSON.stringify([]));
      this.arquitectos = [
        {
          rut: "",
          nombre: "",
          mail: "",
          apellido_mat: "",
          apellido_pat: "",
          direccion: "",
          direccion_complemento: "",
          direccion_num: "",
          comuna: "",
          fono: "",
          fax: "",
          patente: "",
          recordId: "",
        },
      ];
    }

    //CONSTRUCTORA 👷‍♂️🏗️✅
    if (JSON.parse(localStorage.getItem("constructora"))) {
      if (JSON.parse(localStorage.getItem("constructora")).length > 0) {
        this.constructora = JSON.parse(localStorage.getItem("constructora"));
      } else {
        localStorage.setItem("constructora", JSON.stringify([]));
        this.constructora = [
          {
            rut: "",
            nombre: "",
            mail: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_complemento: "",
            direccion_num: "",
            comuna: "",
            fono: "",
            fax: "",
            patente: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("constructora", JSON.stringify([]));
      this.constructora = [
        {
          rut: "",
          nombre: "",
          mail: "",
          apellido_mat: "",
          apellido_pat: "",
          direccion: "",
          direccion_complemento: "",
          direccion_num: "",
          comuna: "",
          fono: "",
          fax: "",
          patente: "",
          recordId: "",
        },
      ];
    }

    //CONSTRUCTOR PROFESIONAL 🏗️🏗️✅
    if (JSON.parse(localStorage.getItem("constructoraProfesional"))) {
      if (
        JSON.parse(localStorage.getItem("constructoraProfesional")).length > 0
      ) {
        this.constructoraProfesional = JSON.parse(
          localStorage.getItem("constructoraProfesional")
        );
      } else {
        localStorage.setItem("constructoraProfesional", JSON.stringify([]));
        this.constructoraProfesional = [
          {
            rut: "",
            nombre: "",
            mail: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_complemento: "",
            direccion_num: "",
            comuna: "",
            fono: "",
            fax: "",
            patente: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("constructoraProfesional", JSON.stringify([]));
      this.constructoraProfesional = [
        {
          rut: "",
          nombre: "",
          mail: "",
          apellido_mat: "",
          apellido_pat: "",
          direccion: "",
          direccion_complemento: "",
          direccion_num: "",
          comuna: "",
          fono: "",
          fax: "",
          patente: "",
          recordId: "",
        },
      ];
    }

    //INSPECTOR OBRA 🧑‍💼🧑‍💼🏗️✅
    if (JSON.parse(localStorage.getItem("inspectorObra"))) {
      if (JSON.parse(localStorage.getItem("inspectorObra")).length > 0) {
        this.inspectorObra = JSON.parse(localStorage.getItem("inspectorObra"));
        if (this.inspectorObra[0].inspectorState == "SI") {
          $("#cuentaInspectorSI").attr("checked", "checked");
        }
        if (this.inspectorObra[0].inspectorState != "SI") {
          $("#cuentaInspectorNO").attr("checked", "checked");
        }
      } else {
        localStorage.setItem("inspectorObra", JSON.stringify([]));
        this.inspectorObra = [
          {
            rut: "",
            nombre: "",
            mail: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_complemento: "",
            direccion_num: "",
            comuna: "",
            fono: "",
            fax: "",
            patente: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("inspectorObra", JSON.stringify([]));
      this.inspectorObra = [
        {
          rut: "",
          nombre: "",
          mail: "",
          apellido_mat: "",
          apellido_pat: "",
          direccion: "",
          direccion_complemento: "",
          direccion_num: "",
          comuna: "",
          fono: "",
          fax: "",
          patente: "",
          recordId: "",
        },
      ];
    }

    //INSPECTOR OBRA PROFESIONAL 🧑‍💼🧑‍💼🏗️✅
    if (JSON.parse(localStorage.getItem("inspectorProfesional"))) {
      if (JSON.parse(localStorage.getItem("inspectorProfesional")).length > 0) {
        this.inspectorProfesional = JSON.parse(
          localStorage.getItem("inspectorProfesional")
        );
      } else {
        localStorage.setItem("inspectorProfesional", JSON.stringify([]));
        this.inspectorProfesional = [
          {
            rut: "",
            nombre: "",
            mail: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_complemento: "",
            direccion_num: "",
            comuna: "",
            fono: "",
            fax: "",
            patente: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("inspectorProfesional", JSON.stringify([]));
      this.inspectorProfesional = [
        {
          rut: "",
          nombre: "",
          mail: "",
          apellido_mat: "",
          apellido_pat: "",
          direccion: "",
          direccion_complemento: "",
          direccion_num: "",
          comuna: "",
          fono: "",
          fax: "",
          patente: "",
          recordId: "",
        },
      ];
    }

    //CUENTA CON REVISOR🧑‍💼🧑‍💼✅
    if (JSON.parse(localStorage.getItem("cuentaRevisor"))) {
      if (JSON.parse(localStorage.getItem("cuentaRevisor")).length > 0) {
        this.cuentaRevisor = JSON.parse(localStorage.getItem("cuentaRevisor"));
        if (this.cuentaRevisor[0].informe == "SI") {
          $("#revisorSi").attr("checked", "checked");
        }
        if (this.cuentaRevisor[0].informe == "NO") {
          $("#revisorNo").attr("checked", "checked");
        }
      } else {
        localStorage.setItem("cuentaRevisor", JSON.stringify([]));
        this.cuentaRevisor = [{ informe: "", numero: "", fecha: "" }];
      }
    } else {
      localStorage.setItem("cuentaRevisor", JSON.stringify([]));
      this.cuentaRevisor = [{ informe: "", numero: "", fecha: "" }];
    }

    // REVISOR INDEPENDIENTE 🧑‍💼🧑‍💼✅
    if (JSON.parse(localStorage.getItem("revisor"))) {
      if (JSON.parse(localStorage.getItem("revisor")).length > 0) {
        this.revisor = JSON.parse(localStorage.getItem("revisor"));
      } else {
        localStorage.setItem("revisor", JSON.stringify([]));
        this.revisor = [
          {
            rut: "",
            nombre: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_num: "",
            direccion_complemento: "",
            direccion_completa: "",
            comuna: "",
            fono: "",
            fax: "",
            mail: "",
            patente: "",
            registro: "",
            categoria: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("revisor", JSON.stringify([]));
      this.revisor = [
        {
          rut: "",
          nombre: "",
          apellido_mat: "",
          apellido_pat: "",
          direccion: "",
          direccion_num: "",
          direccion_complemento: "",
          direccion_completa: "",
          comuna: "",
          fono: "",
          fax: "",
          mail: "",
          patente: "",
          registro: "",
          categoria: "",
          recordId: "",
        },
      ];
    }

    //DECLARACION ✍️✍️ ✅
    if (JSON.parse(localStorage.getItem("declaracion"))) {
      if (JSON.parse(localStorage.getItem("declaracion")).length > 0) {
        this.declaracion = JSON.parse(localStorage.getItem("declaracion"));

        if (this.declaracion[0].declaracionEstructura == "SI") {
          $("#estructuraSi").attr("checked", "checked");
        }
        if (this.declaracion[0].declaracionEstructura == "NO") {
          $("#estructuraNo").attr("checked", "checked");
        }
      } else {
        localStorage.setItem("declaracion", JSON.stringify([]));
        this.declaracion = [
          {
            plano: "",
            denominado: "",
            elaborado: "",
            profesion: "",
            forjas: "",
            numero: "",
            ano: "",
            bienesRa: "",
            declaracionEstructura: "",
          },
        ];
      }
    } else {
      localStorage.setItem("declaracion", JSON.stringify([]));
      this.declaracion = [
        {
          plano: "",
          denominado: "",
          elaborado: "",
          profesion: "",
          forjas: "",
          numero: "",
          ano: "",
          bienesRa: "",
          declaracionEstructura: "",
        },
      ];
    }

    //Tipo Proyecto ✍️✍️ ✅
    if (JSON.parse(localStorage.getItem("tipo_proyecto"))) {
      if (JSON.parse(localStorage.getItem("tipo_proyecto")).length > 0) {
        this.tipo_Proyecto = JSON.parse(localStorage.getItem("tipo_proyecto"));

        if (this.tipo_Proyecto[0].rparcial_proy_res == "SI") {
          $("#rparcial_proy_resSi").attr("checked", "checked");
        }
        if (this.tipo_Proyecto[0].rparcial_proy_res == "NO") {
          $("#rparcial_proy_resNo").attr("checked", "checked");
        }
      } else {
        localStorage.setItem("tipo_proyecto", JSON.stringify([]));
        this.tipo_Proyecto = [
          {
            condominio_tipoA: "",
            condominio_tipoB: "",
            edificaciones_loteo: "",
            urbanizacion_recibida: "",
            urbanizacion_garantizada: "",
            recepcion_urbanizacion: "",
            perm_recep: "",
            perm_numero: "",
            perm_fecha: "",
            perm_sup: "",
            mod_proy_res: "",
            mod_proy_fech: "",
            rparcial_proy_res: "",
            sup_proy_res: "",
            dest_proy_re: "",
          },
        ];
      }
    } else {
      localStorage.setItem("tipo_proyecto", JSON.stringify([]));
      this.tipo_Proyecto = [
        {
          condominio_tipoA: "",
          condominio_tipoB: "",
          edificaciones_loteo: "",
          urbanizacion_recibida: "",
          urbanizacion_garantizada: "",
          recepcion_urbanizacion: "",
          perm_recep: "",
          perm_numero: "",
          perm_fecha: "",
          perm_sup: "",
          mod_proy_res: "",
          mod_proy_fech: "",
          rparcial_proy_res: "",
          sup_proy_res: "",
          dest_proy_re: "",
        },
      ];
    }

    // Características Principales 🧑‍💼🧑‍💼✅
    if (JSON.parse(localStorage.getItem("caract_anteproyecto_obranueva"))) {
      if (
        JSON.parse(localStorage.getItem("caract_anteproyecto_obranueva"))
          .length > 0
      ) {
        this.caract_anteproyecto_obranueva = JSON.parse(
          localStorage.getItem("caract_anteproyecto_obranueva")
        );

        if (
          this.caract_anteproyecto_obranueva[0].anteProyectoAprobado == "NO"
        ) {
          $("#anteproyectoNo").attr("checked", "checked");
        }
        if (
          this.caract_anteproyecto_obranueva[0].anteProyectoAprobado == "SI"
        ) {
          $("#anteproyectoSi").attr("checked", "checked");
        }
        if (
          this.caract_anteproyecto_obranueva[0].edificio_usoPublico == "todo"
        ) {
          $("#edificioDeUsoTodo").attr("checked", "checked");
        }
        if (
          this.caract_anteproyecto_obranueva[0].edificio_usoPublico == "parte"
        ) {
          $("#edificioUsoParte").attr("checked", "checked");
        }
        if (
          this.caract_anteproyecto_obranueva[0].edificio_usoPublico ==
          "no es edificio de uso público"
        ) {
          $("#edificioUsoNoEdificio").attr("checked", "checked");
        }
        if (this.caract_anteproyecto_obranueva[0].crecimientoUrbano == "NO") {
          $("#noCrecimiento").attr("checked", "checked");
        }
        if (this.caract_anteproyecto_obranueva[0].crecimientoUrbano == "SI") {
          $("#siCrecimiento").attr("checked", "checked");
        }
        if (this.caract_anteproyecto_obranueva[0].proyecto_etapas == "no") {
          $("#noProyectoEtapas").attr("checked", "checked");
        }
        if (this.caract_anteproyecto_obranueva[0].proyecto_etapas == "si") {
          $("#siProyectoEtapas").attr("checked", "checked");
        }
        if (this.caract_anteproyecto_obranueva[0].loteo_construccion == "no") {
          $("#noLoteoConst").attr("checked", "checked");
        }
        if (this.caract_anteproyecto_obranueva[0].loteo_construccion == "si") {
          $("#siLoteoConst").attr("checked", "checked");
        }
        if (this.caract_anteproyecto_obranueva[0].loteo_dfl == "no") {
          $("#noLoteoDfl").attr("checked", "checked");
        }
        if (this.caract_anteproyecto_obranueva[0].loteo_dfl == "si") {
          $("#siLoteoDfl").attr("checked", "checked");
        }
      } else {
        localStorage.setItem(
          "caract_anteproyecto_obranueva",
          JSON.stringify([])
        );
        this.caract_anteproyecto_obranueva = [
          {
            anteProyectoAprobado: "",
            anteProyectoAprobadoFecha: "",
            anteProyectoAprobadoRes: "",
            cantidad_etapas: "",
            carga_ocupacionTotal: "",
            carga_ocupacionTotalReconstruccion: "",
            crecimientoUrbano: "",
            densidadOcupacion: "",
            densidadOcupacionReconstruccion: "",
            edificio_usoPublico: "",
            etapas_art9: "",
            etapas_mitigaciones: "",
            explicitar: "",
            fecha_permiso: "",
            fecha_recepcion: "",
            loteo_construccion: "",
            loteo_dfl: "",
            num_permiso: "",
            num_recepcion: "",
            proyecto_etapas: "",
            tipoAlteracion: "",
            tipoAmpliacion: "",
            tipoResRebReh: "",
            tipoResRebRehOtro: "",
            tipoSupresion: "",
            tipo_permiso: "",
            tipo_recepcion: "",
            tipo_reconstruccion: "",
          },
        ];
      }
    }

    //  permisos 📈📈✅
    if (JSON.parse(localStorage.getItem("permisos_recep"))) {
      if (JSON.parse(localStorage.getItem("permisos_recep")).length > 0) {
        this.permisos_recep = JSON.parse(
          localStorage.getItem("permisos_recep")
        );
      } else {
        localStorage.setItem("permisos_recep", JSON.stringify([]));
        this.permisos_recep = [
          {
            tipo_permiso: "",
            permiso: "",
            numero: "",
            fecha: "",
            superficie: "",
            recepcion: "",
            fecha_recep: "",
          },
        ];
      }
    }

    //  ANTECEDENTES QUE SE ADJUNTAN
    if (JSON.parse(localStorage.getItem("antecedentes"))) {
      if (JSON.parse(localStorage.getItem("antecedentes")).length > 0) {
        this.antecedentes = JSON.parse(localStorage.getItem("antecedentes"));

        for (let ant = 0; ant < this.antecedentes.length; ant++) {
          const filaAnt = this.antecedentes[ant];
          console.log("form152", filaAnt);

          if (filaAnt) {
            var aux = "#" + filaAnt.id;

            $(aux).attr("checked", true);
          }
        }
      } else {
        localStorage.setItem("antecedentes", JSON.stringify([]));
        this.antecedentes = [];
      }
    } else {
      localStorage.setItem("antecedentes", JSON.stringify([]));
      this.antecedentes = [];
    }

    //Lista de planos 📈📈✅
    if (JSON.parse(localStorage.getItem("Listado_Planos"))) {
      if (JSON.parse(localStorage.getItem("Listado_Planos")).length > 0) {
        this.Listado_Planos = JSON.parse(
          localStorage.getItem("Listado_Planos")
        );
      } else {
        localStorage.setItem("Listado_Planos", JSON.stringify([]));
        this.Listado_Planos = [
          {
            plano: "",
            contenido: "",
            nota: "",
          },
        ];
      }
    }
  }

  DescargarPdf() {
    this.spinner.show();

    this._wsGenerarPDFService
      .getBase64(this.dataHtml.nativeElement.innerHTML, this.color)
      .subscribe(
        (response) => {
          console.log("response", response);

          let blob = this.convertBase64ToBlobData(response.data);
          let title = localStorage.getItem("formTitle") + ".pdf";
          saveAs(blob, title);
          this.spinner.hide();
        },
        (error) => {
          console.log("error", error);
        }
      );
  }

  convertBase64ToBlobData(
    base64Data: string,
    contentType: string = "image/png",
    sliceSize = 512
  ) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
